import React, {Component} from "react";
import ModuleVideoList from "./ModuleVideoList.js";
import applogic from "../applogic.js";
import {connect} from "react-redux";

class Module extends Component {
    componentDidMount() {
        window.$(this.moduleHeader).click(applogic.handleModuleClick.bind(null, this.props.mod, this.moduleHeader));
    }
    render() {
        let id = this.props.collapseId;
        let classes = 'collapse ' + (this.props.collapse[id] ? 'show' : '');
        return (
            <div className="card" ref={moduleHeader => this.moduleHeader = moduleHeader}>
                <a data-toggle="collapse" href={'#' + id} aria-controls={id} aria-expanded="false">
                    <div className="card-header">
                        <h5 className="module-title-h5 mb-0">
                            {this.props.mod.CourseAcadYear + ' ' + this.props.mod.CourseSemester}
                            &nbsp;- {this.props.mod.CourseCode} - {this.props.mod.CourseName}
                        </h5>
                    </div>
                </a>
                <div id={id} className={classes}>
                    <div className="card-block">
                        <ModuleVideoList moduleVideoList={this.props.mod.moduleVideoList} midx={id}/>
                    </div>
                </div>
            </div>
        );
    }
}
let mapStateToProps = (state) => {
    return {
        collapse: state.collapse
    };
};
export default connect(mapStateToProps)(Module);


// WEBPACK FOOTER //
// ./src/componentsBody/Module.js